	<div class="page-contents">
		<div class="subBlockContainer">
			<div class="breadcrumbWrapper">
				<app-breadcrumb></app-breadcrumb>
			</div>
			<div class="subBlockContent">
				<child-header [title]="title" (closeEvent)="navigateTo('/home')"></child-header>
				<div class="child-body">
					<div class="item-title-wrapper">
						<!-- <div class="title blade-title-font">
							{{title}}
						</div>
						<i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i> -->
						<div class="page-title-description" *ngIf="isAU">
							Keep up to date with all of the events we’re running around Australia all in one convenient place. We’re committed to training, enabling and celebrating with you, our valued partners. Check out what’s happening near you and register to attend. We look forward to seeing you at our next event!	
						</div>
						<div class="page-title-description" *ngIf="!isAU">
							Keep up to date with all of the events we’re running around New Zealand all in one convenient place. We’re committed to training, enabling and celebrating with you, our valued partners. Check out what’s happening near you and register to attend. We look forward to seeing you at our next event!	
						</div>
						<div *ngFor="let banner of bannerList | slice:0:1; let i=index">
							<a href="{{banner.promotionLink}}" target="_blank">
							<img style="width: 728px; height: 90px; margin-top: 18px" class="img-728x90" src="https://marketingdd.blob.core.windows.net/marketing/{{banner.cloudFileName}}" alt="" />
							</a>
						</div>			
						<div class="top-divider"></div>
						<div class="event-title">UPCOMING EVENTS</div>
						<div class="topspot-content">
							<div class="flip-featured" *ngFor="let event of eventList | slice:0:3; let i=index">
								<div class="flip-featured-inner">
									<a [href]="event?.promotionLink" target="_blank">
										<div class="flip-featured-front">
											<ng-container class="upcoming-event float-left">			
												<img class="b-radius-x5" src="https://marketingdd.blob.core.windows.net/marketing/{{event.cloudFileName}}"
													onError="this.src='https://portal.dickerdata.com.au/resourcefiles/DickerData_Logo_BlackRed.png';" alt=""
													target="_blank" />
			
												<!-- <div class="title p-t-10">{{event.title | slice:0:50}}</div>
													<div class="description">{{event.expiryDate | date:'d/M/yy, h:mm a'}}</div> -->
											</ng-container>
										</div>
										<div class="flip-featured-back">
											<div class="flip-title flip-title-height">{{event.title}}</div>
											<!-- <div class="font-x12 p-t-10">{{event.description | slice:0:200}}</div>  -->
											<div class="flip-detail-text">Click to see more details</div>
										</div>
									</a>
								</div>
							</div>
						</div>
						<div class="clearfix"></div>
					</div>
					<div class="event-content-bottom">
						<div class="event-content-bottom-left">
							<div class="cal-container">
								<div class="cal-header">
									<div class="cal-prev" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
										(viewDateChange)="viewDateChange.next(viewDate)">
										<img src="../images/new_ui/prev.png">
									</div>
									<span class="cal-month-title">{{ viewDate | date: 'MMMM yyyy' }}</span>
									<div class="cal-next" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
										(viewDateChange)="viewDateChange.next(viewDate)">
										<img src="../images/new_ui/next.png">
									</div>
								</div>
								<mwl-calendar-month-view [viewDate]="viewDate" [events]="events" [refresh]="refresh"
									(dayClicked)="dayClick($event)" [tooltipPlacement]="tooltipPlacement" [cellTemplate]="customCellTemplate">
								</mwl-calendar-month-view>
							</div>
							<div class="padding-t-x10 align-center">
								<div class="red-dot"></div><span class="physical-event-text">Physical Event</span>
								<div class="gray-dot m-l-20"></div><span class="virtual-event-text">Virtual Event</span>
							</div>
						</div>
						<div class="event-content-bottom-right">
							<div *ngIf="showAll==true" class="event-red-title">{{selectedDate | date:'EEEE, MMMM d, y'}}
							</div>
							<div *ngIf="showAll==false" class="event-red-title">All Upcoming Events</div>
							<div *ngIf="showAll==true" class="show-all-events" (click)="showAllEvents()"> Show All</div>
							<div class="clear-both"></div>
							<hr class="eventlist">
							<div class="no-event" *ngIf="selectedEventList?.length < 1">No Events to show.</div>
							<ng-container *ngFor="let event of selectedEventList; let i=index">
								<div [ngClass]="(event?.virtual == true) ? 'event-list-virtual': 'event-list-physical'">
									<h2 class="mb-0 margin-b-x17">{{event.title}}</h2>
									<div class="event-duration">{{event.startDate | date:'d/MM/yy, h:mm a'}} to
										{{event.expiryDate | date:'d/MM/yy, h:mm a'}}
									</div>
									<p class="event-description">{{event.description}}</p>
									<img class="margin-t-x4"
										[src]="(event?.virtual==true) ? '../images/new_ui/laptop.png' : ''"
										class="float-left">
									<a *ngIf="event?.virtual==true" class="event-link" href="{{event.promotionLink}}"
										target="_blank">{{event.promotionLink}}</a>
									<a *ngIf="!event.virtual && event.locationLink" class="event-link"										
										href="{{event.locationLink}}"
										target="_blank">
										<img class="margin-t-x4 float-left"
										[src]="(event?.virtual==true) ? '../images/new_ui/laptop.png' : '../images/new_ui/location-black.png'"
										>
									</a>
									<a *ngIf="!event.virtual"
										[ngClass]="(!event.virtual && event.locationLink) ? 'event-link': 'event-link-false'"
										href="{{event.promotionLink}}"
										target="_blank">
										{{event.promotionLink}}
									</a>
									<hr class="eventlist">
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
			<loading-screen *ngIf="!loadContent" [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)"></loading-screen>
		</div>
	</div>


	<ng-template #customCellTemplate let-day="day" let-locale="locale" let-openDay="openDay" let-tooltipPlacement="tooltipPlacement" 
	let-highlightDay="highlightDay" let-unhighlightDay="unhighlightDay" let-eventClicked="eventClicked" let-tooltipTemplate="tooltipTemplate" let-tooltipAppendToBody="tooltipAppendToBody">
		<div class="cal-cell-top">
			<span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
		</div>
		<div class="cal-events" *ngIf="day.events.length > 0">
			<div
			class="cal-event"
			*ngFor="let event of day.events"
			[style.backgroundColor]="event.color.primary"
			[ngClass]="event?.cssClass"
			(mouseenter)="highlightDay.emit({event: event})"
			(mouseleave)="unhighlightDay.emit({event: event})"
			[mwlCalendarTooltip]="event.title | calendarEventTitle:'monthTooltip':event"
			[tooltipPlacement]="tooltipPlacement"
			[tooltipEvent]="event"
			[tooltipTemplate]="tooltipTemplate"
			[tooltipAppendToBody]="tooltipAppendToBody"
			(mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })">
			</div>
		</div>
	</ng-template>